import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { from, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AccessService } from '../services/access.service';

export const authGuard = () => {
  const authService = inject(AuthService);
  const accessService = inject(AccessService);
  const router = inject(Router);

  const loaded$ = toObservable(accessService.loaded);

  return authService.user$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) {
        return of(router.createUrlTree(['/sign-in']));
      }
      return loaded$.pipe(
        filter((loaded) => loaded === true),
        take(1),
        switchMap(() => {
          const appUser = accessService.currentUser();
          if (appUser?.status === 'DISABLED') {
            return from(authService.signOut()).pipe(
              map(() => false),
              catchError((err) => {
                console.error('Sign-out in guard failed:', err);
                return of(router.createUrlTree(['/sign-in']));
              }),
            );
          }
          return of(true);
        }),
      );
    }),
  );
};
